import type { LucideIcon } from "lucide-react";
import React from "react";
import { Card, CardContent } from "~/components/ui/card.tsx";

interface FeatureCardProps {
  icon: LucideIcon;
  iconColor: string;
  title: string;
  description: string;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  description,
  icon: Icon,
  iconColor,
  title,
}) => {
  return (
    <Card className="bg-zinc-950 border-white/5 hover:border-white/10 transition-all group">
      <CardContent className="p-8">
        <div className={`mb-6 w-12 h-12 rounded-full ${iconColor} flex items-center justify-center`}>
          <Icon className="w-6 h-6" />
        </div>
        <h3 className="text-xl font-bold text-white mb-4">{title}</h3>
        <p className="text-zinc-500 text-sm leading-relaxed mb-6">{description}</p>
      </CardContent>
    </Card>
  );
};
